import React from 'react';
import { Button } from 'antd';

import type { XoeSendFailureNoticeProps } from '../../types/xoe/XoeUiTypes';

// `message` is only ever session.sendFailure.message — status-derived, never a response body.
const XoeSendFailureNotice: React.FC<XoeSendFailureNoticeProps> = ({ message, onRetry, onDismiss }) => (
	<div className="mg-xoe-notice" role="alert" data-testid="xoe-stream-error">
		<span className="mg-xoe-notice-text">{message}</span>
		<div className="mg-xoe-notice-actions">
			<Button size="small" type="primary" onClick={onRetry} data-testid="xoe-stream-error-retry">
				Retry
			</Button>
			<Button size="small" type="text" onClick={onDismiss} data-testid="xoe-stream-error-dismiss">
				Dismiss
			</Button>
		</div>
	</div>
);

export default XoeSendFailureNotice;
